import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { AppRouter } from "./app/router";
import { Toaster } from "./components/ui/Toaster";
import "./styles/index.css";
import { initMedia } from "./lib/media";
import { openDatePickersOnClick } from "./lib/date-picker-on-click";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root not found — index.html is missing its mount point.");
}
const root = container;

openDatePickersOnClick();

// The media base URL is needed before the first picture renders. Cached after
// the first load, so this resolves at once from then on; it never rejects.
void initMedia().then(render);

function render() {
  createRoot(root).render(
    <StrictMode>
      <Provider store={store}>
        <AppRouter />
        {/* Outside the router on purpose: a toast raised by a request that is
          still in flight during a navigation must not be unmounted by the
          navigation that outran it. */}
        <Toaster />
      </Provider>
    </StrictMode>,
  );
}
